export const LOGIN_SOURCES = {
    CV_BUILDER: 'Cvbuilder-generate',
    OTHER: 'Other_top-login',
    RESULTLIST: 'Resultlist_top-login',
    SALARY: 'Salary_top-login',
    COVER_LETTER: 'coverletter-generate',
    INTERVIEW_COACH: 'interviewCoach',
    JOB_AD: 'jobAd_checkSalary_header',
    RESULTLIST_FACET_SALARY: 'resultlist_facet-salary',
    RESULTLIST_JOBCARD_SALARY: 'resultlist_jobcard-salary',
    LOGIN: 'LoginPage',
    REGISTRATION: 'RegistrationPage',
    CV_TO_JOB_FIT: 'cvToJobFit',
    SEARCH_ASSISTANT: 'searchAssistant',
    HOMEPAGE_LOGIN_WALL: 'homepage_onLoad',
};
export const FORM_TYPES = {
    LOGIN: 'login',
    REGISTRATION: 'registration',
    REGISTRATION_SUCCESS: 'registrationSuccess',
    RESET_PASSWORD: 'resetPassword',
    GOOGLE_SUCCESS: 'googleSuccess',
    BASIC_TWO_STEP: 'basicTwoStep',
    FULLSCREEN_TWO_STEP: 'fullscreenTwoStep',
};
export const WRAPPER_TYPES = {
    PAGE: 'page',
    MODAL: 'modal',
    FORM: 'form',
};
//# sourceMappingURL=paramsConfig.js.map